import cn from 'classnames';
import ApplePayButtonNew from 'components/apple-pay-button/new';
import PaypalExpressButtonNew from 'components/paypal-express-button/new';
import { useCart } from 'contexts/cart';

interface ExpressCheckoutButtonsProps {
  disabled: boolean;
}

/**
 * Component to display express checkout buttons
 */
const ExpressCheckoutButtons: React.FC<ExpressCheckoutButtonsProps> = ({ disabled }) => {
  const { oosItems } = useCart();
  return (
    <div
      className={cn('flex w-full items-center gap-3', disabled && 'pointer-events-none opacity-20')}
      data-test="express-checkout-buttons-container"
    >
      <ApplePayButtonNew className="h-10 grow" data-test="apple-pay-button" />
      <PaypalExpressButtonNew oosItems={oosItems} data-test="paypal-express-button" />
    </div>
  );
};

export default ExpressCheckoutButtons;
